// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.league-tournament-staff-member{
    width: 100%;
    grid-column: 1 / span 5;
}

.staff-member__container {
    display: flex;
    background: rgba(255, 255, 255, 1);
    border-radius: 8px;
    align-items: center;
    justify-content: space-between;
}

.staff-member__card {
    display: flex;
} 

.staff-member__card img,
.staff-member__card span 
{
    width: calc( var(--space-x2) * 2 );
    height: calc( var(--space-x2) * 2 );
    border-radius: 50%;
    margin-right: calc( var(--space) );
    margin-left: calc( var(--space) + var(--space-half) );
}

.staff-member__card span {
    font-size: 90px;
    border-radius: 50%;
    color: var( --secondary-color );
    text-align: center;
}

.staff-member__card__info .baloa-normal-text {
    color: var( --primary-dark-color) !important;
}

.staff-member__card__info .baloa-headline-2{
    color: var(--primary-very-dark-color) !important;
}

.staff-member__btns-actions {
    display: flex;
    margin-top: var( --space );
    justify-content: flex-end;
    flex-direction: column;
    align-items: flex-end;
    align-content: flex-end;  
    margin-right: var(--space);
    margin-bottom: var(--space);
}

.staff-member__btns-actions .button { 
    grid-template-columns: none; 
    grid-template-areas: none;
    grid-column-gap: 0;
}

.staff-member__btns-actions .baloa-hyperlink {
    color: var(--new-green-color) !important;
    cursor: pointer;
    margin-bottom: var(--space);
}

.staff-member__btns-actions .button:last-of-type {
    border: 2px solid var( --error-color );
    color: #ff515b;
    text-transform: none;
}

.staff-member__btns-actions .button:last-of-type:hover {
    background-color: var(--error-color);
    color: #FFFFFF;
}

.staff-member__registered-championships__container {
    border-top: 1px solid var( --border-card-color );
    margin-top: var( --space-x2 );
    padding-top: calc( var(--space) + var(--space-half) );
}

.staff-member__registered-championships__container ul {
    list-style-type:none;
    padding: 0;
    margin: var( --space ) 0 0 0;
}

.staff-member__registered-championships__container ul li{
    padding: 16px;
}

.registered-championships__card {
    display: flex;
    align-items: center; 
    justify-content: space-between;   
}

.registered-championships__card__info p {
    margin-bottom: var(--space-half);
}

.registered-championships__card span {
    color: var( --basic-green-color );
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-tournament-staff-member/LeagueTournamentStaffMemberComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;;;IAGI,kCAAkC;IAClC,mCAAmC;IACnC,kBAAkB;IAClB,kCAAkC;IAClC,qDAAqD;AACzD;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;IACtC,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,gDAAgD;IAChD,6BAA6B;IAC7B,qDAAqD;AACzD;;AAEA;IACI,oBAAoB;IACpB,UAAU;IACV,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iCAAiC;AACrC","sourcesContent":[".league-tournament-staff-member{\n    width: 100%;\n    grid-column: 1 / span 5;\n}\n\n.staff-member__container {\n    display: flex;\n    background: rgba(255, 255, 255, 1);\n    border-radius: 8px;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.staff-member__card {\n    display: flex;\n} \n\n.staff-member__card img,\n.staff-member__card span \n{\n    width: calc( var(--space-x2) * 2 );\n    height: calc( var(--space-x2) * 2 );\n    border-radius: 50%;\n    margin-right: calc( var(--space) );\n    margin-left: calc( var(--space) + var(--space-half) );\n}\n\n.staff-member__card span {\n    font-size: 90px;\n    border-radius: 50%;\n    color: var( --secondary-color );\n    text-align: center;\n}\n\n.staff-member__card__info .baloa-normal-text {\n    color: var( --primary-dark-color) !important;\n}\n\n.staff-member__card__info .baloa-headline-2{\n    color: var(--primary-very-dark-color) !important;\n}\n\n.staff-member__btns-actions {\n    display: flex;\n    margin-top: var( --space );\n    justify-content: flex-end;\n    flex-direction: column;\n    align-items: flex-end;\n    align-content: flex-end;  \n    margin-right: var(--space);\n    margin-bottom: var(--space);\n}\n\n.staff-member__btns-actions .button { \n    grid-template-columns: none; \n    grid-template-areas: none;\n    grid-column-gap: 0;\n}\n\n.staff-member__btns-actions .baloa-hyperlink {\n    color: var(--new-green-color) !important;\n    cursor: pointer;\n    margin-bottom: var(--space);\n}\n\n.staff-member__btns-actions .button:last-of-type {\n    border: 2px solid var( --error-color );\n    color: #ff515b;\n    text-transform: none;\n}\n\n.staff-member__btns-actions .button:last-of-type:hover {\n    background-color: var(--error-color);\n    color: #FFFFFF;\n}\n\n.staff-member__registered-championships__container {\n    border-top: 1px solid var( --border-card-color );\n    margin-top: var( --space-x2 );\n    padding-top: calc( var(--space) + var(--space-half) );\n}\n\n.staff-member__registered-championships__container ul {\n    list-style-type:none;\n    padding: 0;\n    margin: var( --space ) 0 0 0;\n}\n\n.staff-member__registered-championships__container ul li{\n    padding: 16px;\n}\n\n.registered-championships__card {\n    display: flex;\n    align-items: center; \n    justify-content: space-between;   \n}\n\n.registered-championships__card__info p {\n    margin-bottom: var(--space-half);\n}\n\n.registered-championships__card span {\n    color: var( --basic-green-color );\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
